import type { CoinType } from '../cointype/CoinTypeStore';

import type { SlotBattle } from './types';

/**
 * Whether a battle shows in this lobby (GS-1032 decisions 4 and 16). A battle is single-coin: it shows
 * only in its own coin's world, so an SC|GC event shows each mode in its own world. A closing waiting to be
 * claimed is the exception and shows in both worlds, since the player has to see it to collect it.
 *
 * core already answers this way. The client holds to it too, so a lobby never draws another world's live
 * battle, a coin switch before the new lobby's read lands included.
 */
export function isBattleForLobby(battle: SlotBattle | null, lobbyCoin: CoinType): boolean {
  if (!battle) {
    return false;
  }

  return Boolean(battle.closing) || battle.coinType === lobbyCoin;
}

/** The battle as the lobby may show it: the battle itself, or null when it belongs to the other world. */
export function selectLobbyBattle(battle: SlotBattle | null, lobbyCoin: CoinType): SlotBattle | null {
  return isBattleForLobby(battle, lobbyCoin) ? battle : null;
}
